import React, { FunctionComponent } from 'react';

import styles from './VerifiedBanner.scss';
import { Trans } from 'react-i18next';
import { CheckBadgeIcon } from './VerifiedBannerIcons/CheckBadgeIcon';
import { PiggyBankIcon } from './VerifiedBannerIcons/PiggyBankIcon';
import { MoneyBagIcon } from './VerifiedBannerIcons/MoneyBagIcon';

const VerifiedBanner: FunctionComponent = () => {
  return (
    <div className={styles.container} id="verifiedBanner">
      <div className={styles.bannerWrapper}>
        <div className={styles.bannerItem}>
          <CheckBadgeIcon />
          <p>
            <Trans i18nKey="page.verifiedBanner.copy1">
              <span className={styles.copyBold}>verifies</span>
            </Trans>
          </p>
        </div>
        <div className={styles.bannerItem}>
          <PiggyBankIcon />
          <p>
            <Trans i18nKey="page.verifiedBanner.copy2">
              <span className={styles.copyBold}>directly transferred</span>
            </Trans>
          </p>
        </div>
        <div className={styles.bannerItem}>
          <MoneyBagIcon />
          <p>
            <Trans i18nKey="page.verifiedBanner.copy3">
              <span className={styles.copyBold}>raise over £5bn</span>
            </Trans>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifiedBanner;
